import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppModule } from './app.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_PAGINATOR_INTL_PROVIDER } from '@angular/material/paginator';
import { AgGridModule } from 'ag-grid-angular';

// NG-ZORRO locale configuration
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';

// Register English locale data globally
registerLocaleData(en);

if (typeof document !== 'undefined') {
  import('bootstrap');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch()),
    importProvidersFrom(BrowserAnimationsModule),
    importProvidersFrom(
      ToastrModule.forRoot({
        positionClass: 'toast-top-right',
        timeOut: 3000,
        progressBar: true,
      })
    ),
    importProvidersFrom(AppModule), provideAnimationsAsync(),
    provideAnimations(),
    importProvidersFrom(HttpClientModule),
    MAT_PAGINATOR_INTL_PROVIDER,
    // importProvidersFrom(AgGridModule)
    importProvidersFrom(AgGridModule),
    // Global locale configuration for NG-ZORRO
    { provide: NZ_I18N, useValue: en_US },
    { provide: LOCALE_ID, useValue: 'en-US' },
  ],
};
